import styled from '@emotion/styled';
import Theme from 'App.theme';

export const PageContainer = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
`;

export const BodyContainer = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const MainContainer = styled.main`
  flex: 1;
  padding: 3rem;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #ffffff;
  box-shadow: inset 10px 10px 50px ${Theme.greys.GREY1}95;
`;
